module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_6000.180e1860.png";